import { useEffect, useRef, useState } from 'react'
import IconMenuTimer from '../../../assets/icons/ico-menu-timer.png'
import IconReports from '../../../assets/icons/ico-reports.png'
import IconMenuAlert from '../../../assets/icons/ico-menu-alert.png'
import NotificationMenuItem from './notification-menu-item'
import { NotificationsStyle, ModalContentCC, ModalContentCCFirst } from './styles'
import Modal from 'react-modal'
import { updateDiagnostic } from 'infra/services/diagnostics'
import { dateFormat, getQuarterName, getReportType } from 'presentation/utils/helpers/helpers'
import { idSanitizeDiagnostics } from 'presentation/utils/id-sanitize/id-sanitize'
import { fetchReportsList } from 'infra/services/reports'
import { fetchNotification, fetchBillsCloseExpiration, fetchBillsExpiration, fetchClinicalCure, fetchPlateReady, fetchNotificationPreferences } from 'infra/services/notifications'
import Loading from '../loading/loading'
import { useLocation } from 'react-router-dom'
import { createFarmLactation, fetchFarmLactations } from 'infra/services/farm-lactations'
import moment from 'moment'
import { translate } from '../../../../i18n/index'
import { Notifications } from '@mui/icons-material'
import { Box, CircularProgress } from '@mui/material'

const NotificationMenu = () => {
  const [open, setOpen] = useState(false)
  const [modalClinicalCureIsOpen, setModalClinicalCureIsOpen] = useState(false)
  const [modalStartCC, setModalStartCC] = useState(false)
  const [modalStartCCDenied, setModalStartCCDenied] = useState(false)
  const [modalLactationIsOpen, setModalLactationIsOpen] = useState(false)
  const [valuesLactationCow, setValuesLactationCow] = useState('')
  const [platesClinicalCure, setPlatesClinicalCure] = useState([])
  const [atualClinicalCure, setAtualClinicalCure] = useState(0)
  const [selectedOption, setSelectedOption] = useState('')
  const [loading, setLoading] = useState(false)
  const [notificationsPush, setNotificationsPush] = useState([])
  const [notificationsMeta, setNotificationsMeta] = useState({
    clinicalCure: {
      title: null,
      description: null,
      answerLaterButton: false,
      disablePopupButton: false
    },
    lactationCow: {
      title: null,
      description: null,
      answerLaterButton: false,
      disablePopupButton: false
    }
  })
  const notificationsBox = useRef(null)
  const location = useLocation()
  const modalStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      padding: '30px'
    }
  }

  const handleClickOutside = (event) => {
    if (notificationsBox.current && notificationsBox?.current?.contains(event.target)) {
      return
    }
    setOpen(false)
    setModalClinicalCureIsOpen(false)
  }

  const submitPlaca = async (item) => {
    setLoading(true)
    try {
      if (selectedOption) {
        await updateDiagnostic(idSanitizeDiagnostics(item['@id']), {
          diagnosticClinicalCures: [
            ...item.diagnosticClinicalCures?.map(clinicalCure => ({
              id: clinicalCure.id,
              preliminaryStatus: selectedOption,
              executedManually: true
            }))
          ]
        })
        setSelectedOption('')
        if (atualClinicalCure + 1 === platesClinicalCure.length) {
          setModalClinicalCureIsOpen(false)
        } else {
          setAtualClinicalCure(atualClinicalCure + 1)
        }
      } else {
        alert('Selecione uma opção')
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.error(error.message)
    }
  }

  const submitLactationCow = async () => {
    try {
      await createFarmLactation({
        date: new Date().toISOString(),
        quantity: parseInt(valuesLactationCow)
      })
    } catch (error) {
      console.error(error)
    }

    setModalLactationIsOpen(false)
  }

  const showNotificationByRoute = (route) => {
    if (route === location.pathname.replace('/', '')) return true
    if (route === 'home-ubere' && location.pathname === '/') return true
    return false
  }

  const answerLaterButtonHandle = (type) => {
    if (type === 'clinicalCure') {
      sessionStorage.setItem('ccNotification', 'true')
      setModalStartCCDenied(false)
      setModalClinicalCureIsOpen(false)

      if (!notificationsPush.filter(item => item.title === 'Responder perguntas de Cura Clínica').length) {
        setNotificationsPush(prev => ([
          ...prev,
          {
            icon: IconMenuAlert,
            title: 'Responder perguntas de Cura Clínica',
            url: '',
            action: () => {
              setOpen(false)
              setModalClinicalCureIsOpen(true)
            }
          }
        ]))
      }
    } else if (type === 'lactationCow') {
      sessionStorage.setItem('lcNotification', 'true')
      setModalLactationIsOpen(false)

      if (!notificationsPush.filter(item => item.title === 'Atualizar Vacas em Lactação').length) {
        setNotificationsPush(prev => ([
          ...prev,
          {
            icon: IconMenuAlert,
            title: 'Atualizar Vacas em Lactação',
            url: '',
            action: () => {
              setOpen(false)
              setModalLactationIsOpen(true)
            }
          }
        ]))
      }
    }
  }

  useEffect(() => {
    //if (localStorage.getItem('refreshNotification') === 'true') {
    (async () => {
      setLoading(true)

      // Busca de notificações de relatórios
      const reports = await fetchReportsList({ source: 'app', unread: true, farms: atob(window.localStorage.getItem('farm-id')) })

      reports.data['hydra:member'].reverse().forEach(report => {
        setNotificationsPush(prev => ([
          ...prev,
          {
            icon: IconReports,
            title: 'Relatório - ' + getReportType(report.type),
            url: '/ubere/relatorios-processados',
            id: parseInt(report['@id'].split('/')[report['@id'].split('/').length - 1])
          }
        ]))
      })

      const notifications = await fetchNotification()
      const preferenceNotifications = await fetchNotificationPreferences()
      // Modal de Cura Clinica
      const ccNotification = notifications.data['hydra:member'].filter(item => item.category.name.toUpperCase() === 'CURA CLÍNICA')
      const preferenceCCNotification = preferenceNotifications.data['hydra:member'].find(item => item.category.name.toUpperCase() === 'CURA CLÍNICA')

      if (ccNotification.length && ccNotification[0].enabled && preferenceCCNotification?.enabled) {
        const clinicalCure = await fetchClinicalCure() // Busca de Cura clinica

        if (clinicalCure.data['hydra:member'] && clinicalCure.data['hydra:member'].length) {
          clinicalCure.data['hydra:member'].forEach(item => {
            setPlatesClinicalCure(prev => ([
              ...prev,
              {
                ...item,
                quarter: getQuarterName(item),
                date: dateFormat(item.collectedAt).format('DD/MM/YY'),
                earTag: item?.animal?.earTag
              }
            ]))
          })
          setNotificationsMeta((prev) => ({
            ...prev,
            clinicalCure: {
              title: ccNotification[0].title,
              description: ccNotification[0].description,
              answerLaterButton: ccNotification[0].answerLaterButton,
              disablePopupButton: ccNotification[0].disablePopupButton
            }
          }))
        }

        if (sessionStorage.getItem('ccNotification')) {
          setNotificationsPush(prev => ([
            ...prev,
            {
              icon: IconMenuAlert,
              title: 'Responder perguntas de Cura Clínica',
              url: '',
              action: () => {
                setOpen(false)
                setModalClinicalCureIsOpen(true)
              }
            }
          ]))
        } else if (
          !!ccNotification &&
          ccNotification?.length > 0 &&
          clinicalCure?.data['hydra:member']?.length &&
          showNotificationByRoute(ccNotification[0].linkAppWebScreen[0])
        ) {
          setModalStartCC(true)
        }
      }

      const lactationsFarm = await fetchFarmLactations()
      // Busca Modal de Vacas em Lactação
      const lcNotification = notifications.data['hydra:member'].filter(item => item.category.name.toUpperCase() === 'VACAS EM LACTAÇÃO')
      const FarmLactations = lactationsFarm.data['hydra:member'].map((item) => moment(item.date).format('MMMM'))
      const lastMonth = moment().startOf('month').format('MMMM')
      const filterActualMonth = FarmLactations.filter((item) => item === lastMonth)
      const preferenceLCNotification = preferenceNotifications.data['hydra:member'].find(item => item.category.name.toUpperCase() === 'VACAS EM LACTAÇÃO')

      if (lcNotification.length && lcNotification[0].enabled && preferenceLCNotification?.enabled && filterActualMonth.filter(i => i === lastMonth).length < 1 && showNotificationByRoute(lcNotification[0].linkAppWebScreen[0])) {
        setNotificationsMeta((prev) => ({
          ...prev,
          lactationCow: {
            title: lcNotification[0].title,
            description: lcNotification[0].description,
            answerLaterButton: lcNotification[0].answerLaterButton,
            disablePopupButton: lcNotification[0].disablePopupButton
          }
        }))

        if (sessionStorage.getItem('lcNotification')) {
          setNotificationsPush(prev => ([
            ...prev,
            {
              icon: IconMenuAlert,
              title: 'Atualizar Vacas em Lactação',
              url: '',
              action: () => {
                setOpen(false)
                setModalLactationIsOpen(true)
              }
            }
          ]))
        } else if (lcNotification.length && showNotificationByRoute(lcNotification[0].linkAppWebScreen[0])) {
          setModalLactationIsOpen(true)
        }
      }

      // Busca de Placas Prontas
      const platesReady = await fetchPlateReady({ category: 1 })
      const preferencePlatesReadyNotification = preferenceNotifications.data['hydra:member'].find(item => item.category.name.toUpperCase() === 'PLACAS PRONTAS')
      if (platesReady.data['hydra:member'] && preferencePlatesReadyNotification?.enabled) {
        platesReady.data['hydra:member']
          .filter(plate => !!plate.plateBarcode)
          .forEach(item => {
            setNotificationsPush(prev => ([
              ...prev,
              {
                icon: IconMenuTimer,
                title: translate('labelPlaca') + ` ${item.plateBarcode} pronta para leitura`,
                url: `/ubere/leitura-de-resultados/${idSanitizeDiagnostics(item['@id'])}`
              }
            ]))
          })
      }

      try {
        // Busca de Faturas próximas ao Vencimento
        const billsCloseExpiration = await fetchBillsCloseExpiration()
        const preferenceBillsCloseNotification = preferenceNotifications?.data['hydra:member'].find(item => item.category.name.toUpperCase() === 'FATURAS PRÓXIMAS AO VENCIMENTO')
        if (billsCloseExpiration?.data?.titulosEncontrados?.length && preferenceBillsCloseNotification?.enabled) {
          setNotificationsPush(prev => ([
            ...prev,
            {
              icon: IconMenuAlert,
              title: 'Faturas próximas ao Vencimento',
              url: '/minhas-contas'
            }
          ]))
        }
      } catch (e) {
        console.error(e)
      }

      // Busca de Faturas Vencidas
      try {
        const billsExpiration = await fetchBillsExpiration()
        const preferenceBillsExpirationNotification = preferenceNotifications?.data['hydra:member'].find(item => item.category.name.toUpperCase() === 'FATURAS VENCIDAS')
        if (billsExpiration?.data?.titulosEncontrados?.length && preferenceBillsExpirationNotification?.enabled) {
          setNotificationsPush(prev => ([
            ...prev,
            {
              icon: IconMenuAlert,
              title: 'Faturas Vencidas',
              url: '/minhas-contas'
            }
          ]))
        }
      } catch (e) {
        console.error(e)
      }

      setLoading(false)
      localStorage.setItem('refreshNotification', 'false')
    })()
    //}
  }, [])

  useEffect(() => {
    if (open) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }
    return () => { document.removeEventListener('mousedown', handleClickOutside) }
  }, [open, platesClinicalCure, modalStartCC])

  return (
    <>
      <NotificationsStyle ref={notificationsBox} onClick={() => setOpen(!open)}>
        <Notifications style={{ color: '#fff', fontSize: 30 }} />

        {loading && (
          <Box
            style={{
              display: 'flex',
              borderRadius: '50%',
              height: '20px',
              width: '20px',
              margin: 0,
              position: 'absolute',
              marginLeft: '10px',
              top: '7px'
            }}
          >
            <CircularProgress
              style={{
                height: '20px',
                width: '20px',
                color: '#99175c'
              }}
            />
          </Box>
        )}

        {!loading && (
          <div className='headerIconNotification'>
            <span>{notificationsPush.length}</span>
          </div>
        )}
        {open && (
          <div className="list notification-menu-drop">
            <div className="notification-menu-drop-title">
              <h3>{translate('labelNotificacoes')}</h3>
              <span>{notificationsPush.length}</span>
            </div>
            <div className="notification-menu-drop-list">
              {notificationsPush.map((item, index) => (
                <NotificationMenuItem
                  key={index}
                  icon={item.icon}
                  url={item.url}
                  title={item.title}
                  action={item.action}
                />
              ))}
              {loading && <Loading />}
            </div>
          </div>
        )}
      </NotificationsStyle>

      {/* Modais de vaca em lactação */}
      <Modal isOpen={modalLactationIsOpen && !modalStartCC && !modalStartCCDenied} style={modalStyles}>
        <ModalContentCC>
          <p>{notificationsMeta.lactationCow.title}</p>
          <div className="descriptionCC" dangerouslySetInnerHTML={{ __html: notificationsMeta?.lactationCow?.description?.replace('\n', '<br/>') }} />

          <div className="input-box">
            <label>{translate('labelVacasLactacao')}:</label>
            <input
              type="text"
              onChange={(e) => {
                setValuesLactationCow(e.target.value)
              }}
            />
          </div>

          <div className="buttons">
            {notificationsMeta.lactationCow.disablePopupButton &&
              <button onClick={() => setModalLactationIsOpen(false)}>Desativar pop-up</button>
            }

            {notificationsMeta.lactationCow.answerLaterButton &&
              <button onClick={() => answerLaterButtonHandle('lactationCow')}>Responder depois</button>
            }

            <button
              className="next"
              onClick={submitLactationCow}>
              Enviar
            </button>
          </div>
        </ModalContentCC>
      </Modal>

      {/* Modais de cura clínica */}
      <Modal isOpen={modalStartCC} style={modalStyles}>
        <ModalContentCCFirst>
          <p>{notificationsMeta.clinicalCure.title}</p>
          <div className="descriptionCC" dangerouslySetInnerHTML={{ __html: notificationsMeta?.clinicalCure?.description }} />
          <div className="buttons">
            <button onClick={() => {
              setModalStartCC(false)
              answerLaterButtonHandle('clinicalCure')
            }}>{translate('labelNao')}</button>
            <button onClick={() => {
              setModalStartCC(false)
              setModalClinicalCureIsOpen(true)
            }}>{translate('labelSim')}</button>
          </div>
        </ModalContentCCFirst>
      </Modal>

      <Modal isOpen={modalStartCCDenied} style={modalStyles}>
        <ModalContentCCFirst>
          <p>Gostaria de desativar função ou responder depois?</p>
          <div className="buttons">
            {notificationsMeta.clinicalCure.disablePopupButton &&
              <button onClick={() => setModalStartCCDenied(false)}>Desativar pop-up</button>
            }
            {notificationsMeta.clinicalCure.answerLaterButton &&
              <button onClick={() => answerLaterButtonHandle('clinicalCure')}>Responder depois</button>
            }
          </div>
        </ModalContentCCFirst>
      </Modal>

      <Modal isOpen={modalClinicalCureIsOpen} style={modalStyles}>
        {!!platesClinicalCure.length && platesClinicalCure[atualClinicalCure] &&
          <ModalContentCC>
            <div className="steps">Passo: {atualClinicalCure + 1} de {platesClinicalCure.length}</div>
            <p>Informe o que aconteceu com o brinco
              <b> {platesClinicalCure[atualClinicalCure].earTag} </b>
              referente a data
              <b> {platesClinicalCure[atualClinicalCure].date} </b>
              {platesClinicalCure[atualClinicalCure].quarter.split(' ').length - 1 > 1 ? 'e quartos' : 'e quarto'}
              <b> {platesClinicalCure[atualClinicalCure].quarter} </b>
            </p>

            <div className="options">
              <button
                className={selectedOption === 'yes' ? 'active' : 'result-card-button'}
                onClick={() => setSelectedOption('yes')}
              >
                O grumo desapareceu e não voltou mais neste quarto <b>{platesClinicalCure[atualClinicalCure].quarter}</b> (CUROU)
              </button>
              <button
                className={selectedOption === 'no' ? 'active' : 'result-card-button'}
                onClick={() => setSelectedOption('no')}
              >
                Voltou ou continuou dando grumo neste quarto <b>{platesClinicalCure[atualClinicalCure].quarter}</b> (NÃO CUROU)
              </button>
              <button
                className={selectedOption === 'discarded' ? 'active' : 'result-card-button'}
                onClick={() => setSelectedOption('discarded')}
              >
                Foi descartada
              </button>
              <button
                className={selectedOption === 'dried' ? 'active' : 'result-card-button'}
                onClick={() => setSelectedOption('dried')}
              >
                {translate('labelSeca')}
              </button>
            </div>

            <div className="buttons">
              {notificationsMeta.clinicalCure.disablePopupButton && <button>Desativar pop-up</button>}
              {notificationsMeta.clinicalCure.answerLaterButton &&
                <button onClick={() => answerLaterButtonHandle('clinicalCure')}>Responder depois</button>
              }

              <button
                className="next"
                disabled={loading}
                onClick={() => submitPlaca(platesClinicalCure[atualClinicalCure])}>
                {atualClinicalCure + 1 === platesClinicalCure.length ? 'Finalizar' : 'Proximo'}
              </button>
            </div>
          </ModalContentCC>
        }
      </Modal>
    </>
  )
}

export default NotificationMenu
